<template>
    <div class="layout__container">
        <div class="layout__padding-20-0">
            <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                <h2 class="text__align-center text__colour-teal layout__margin__top-10">My Orders</h2>
            </div>
            <div class="">
                <div class="layout__width-90 layout__padding-clear">
                    <div class="">
                        <div class="layout__padding-clear layout__width-100">
                            <el-radio-group v-model="view" :max="1" class="layout__padding-clear layout__width-100"
                                            v-on:change="getTo">
                                <el-radio-button class="component__forms-7 layout__padding-60px-0" label="All"
                                                 :key="'All'">All
                                </el-radio-button>
                                <el-radio-button class="component__forms-7 layout__padding-60px-0" label="PDFUpload"
                                                 :key="'PDFUpload'">Instant Print
                                </el-radio-button>
                                <el-radio-button class="component__forms-7 layout__padding-60px-0" label="Photofixr"
                                                 :key="'Photofixr'">Photofixr&trade;
                                </el-radio-button>
                                <el-radio-button class="component__forms-7 layout__padding-60px-0" label="Toolkit"
                                                 :key="'Toolkit'">Marketing Toolkit
                                </el-radio-button>
                                <el-radio-button class="component__forms-7 layout__padding-60px-0" label="Bespoke"
                                                 :key="'Bespoke'">Bespoke
                                </el-radio-button>
                                <el-radio-button class="component__forms-7 layout__padding-60px-0" label="Email"
                                                 :key="'Email'">Email
                                </el-radio-button>
                                <el-radio-button class="component__forms-7 layout__padding-60px-0" label="IMA"
                                                 :key="'IMA'">Directmailr&trade;
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
            </div>

            <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams" class="layout__padding-20-0">
                <div class="layout__padding-clear text__align-center layout__width-100">
                    <div class="component__forms-4">
                        <p>Freetext Search</p>
                        <el-form ref="search">
                            <el-form-item prop="searchParams">
                                <el-input placeholder="Search" v-model="searchParams.orderFreeText"
                                          clearable
                                          autofocus></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="component__forms-4">
                        <p>Order Status</p>
                        <el-form ref="jobStatus">
                            <el-form-item prop="search">
                                <el-select v-model="searchParams.orderStatus" placeholder="Job status" clearable>
                                    <el-option v-for="status in ravensworth.customerOrderStatus.options"
                                               :key="status.id"
                                               :label="status.text"
                                               :value="status.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="component__forms-4">
                        <p>From Ordered Date</p>
                        <el-form-item prop="startDate">
                            <el-date-picker
                                    v-model="searchParams.startDate"
                                    type="date"
                                    format="dd-MM-yyyy"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="component__forms-4">
                        <p>To Ordered Date</p>
                        <el-form-item prop="endDate">
                            <el-date-picker
                                    v-model="searchParams.endDate"
                                    type="date"
                                    format="dd-MM-yyyy"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!--<div class="component__forms-4">-->
                    <el-button class="button-dark-teal button__base layout__width-150px text__align-center layout__margin__top-20"
                               id="getCustomerOrders" v-on:click="getOrders('searchParams')">Search Orders
                    </el-button>

                    <el-button class="layout__display-none"
                               id="getCustomerOrdersPagination" v-on:click="getPaginatedResults()">
                    </el-button>
                    <!--</div>-->
                </div>

            </el-form>

        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import {pagination} from '@/mixins/Pagination.js';
    import Router from '../../router';
    import moment from 'moment';

    export default {
        name: "customerOrdersSearch",
        mixins: [axios, dataFormatter, backing, pagination],
        props: {
            searchParams: Object,
            orders: Array,
            view: String,
            loading: Boolean,
            resultsCount: String
        },
        data() {
            return {
                finalQuery: '',
                queryRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/customerSearch?`,
                parameters: [],
                queryOptions: [],
                freetextQueryOptions: [],
                sourceQueryOptions: [],
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                resourcePath: '/odata/OrderSearch?$filter=(status ne \'DRAFT\')+and+(status ne \'DELETED\')+and+(status ne \'CANCELLED\')+and+(status ne \'REJECTED\')+and+',
                queryConcatAnd: '+and+',
                queryConcatOr: '+or+',
                jobStatus: '',
                convertFromDate: '',
                convertToDate: '',
                statuses: [
                    {status: 'ANY STATUS'},
                    {status: 'ORDERED'},
                    {status: 'PRINTED'},
                    {status: 'COMPLETED'},
                    {status: 'DESPATCHED'},
                    {status: 'DRAFT'},
                    {status: 'INVOICED'},
                    {status: 'CANCELLED'},
                    {status: 'REJECTED'}
                ],
                products: [
                    {product: 'ANY PRODUCT'},
                    {product: 'TOOLKIT'},
                    {product: 'EMAIL'},
                    {product: 'BESPOKE'},
                    {product: 'PDFUPLOAD'},
                    {product: 'PHOTOFIXR'},
                    {product: 'DELIVERY'}
                ],
                pickerOptions: {
                    shortcuts: [{
                        text: 'Last week',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', start);
                        }
                    }, {
                        text: 'Last month',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            console.log(start.toLocaleDateString('en-GB'))
                            picker.$emit('pick', start);
                        }
                    }, {
                        text: 'Last 3 months',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', start);
                        }
                    }]
                },
                rules: {
                    salesDateRange: [{
                        required: true,
                        message: 'To/From Dates required',
                        trigger: 'blur'
                    }],
                    startDate: [{
                        required: true,
                        message: 'Start Date required',
                        trigger: 'blur'
                    }],
                    endDate: [{
                        required: true,
                        message: 'End Date required',
                        trigger: 'blur'
                    }]
                },
            }
        },
        // computed: {
        //     toDate() {
        //         return this.searchParams.orderToDate;
        //     }
        // },
        watch: {
            // toDate() {
            //     if (this.convertDate(this.searchParams.orderToDate) < this.convertDate(this.searchParams.orderFromDate)) {
            //         alert('Select a To Date after the From Date')
            //         this.searchParams.orderToDate = null
            //     }
            // }
        },
        created() {
            // removal of this line requested by Rifat: this.isUserAuthorised();
            console.log('search')
            console.log(window.sessionStorage.getItem("_customerOrdersSearch"))

            if (typeof this.returnCookie("_token") === 'undefined') {
                let parameters = window.location.search.split('=')

                console.log(parameters[1])

                if (parameters[1]) {
                    const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                    Axios.get(getCurrentLoginContext,
                        this.returnHeaderUsingParameter(parameters[1]))

                        .then(response => {
                            this.persistUserSessionUsingParameter(parameters[1], response)
                            console.log('finished persisting the cookies')
                            // EventBus.$emit('customerSearch', this.returnHeaderUsingToken())
                            // EventBus.$emit('update', this.returnAllCookies())
                        });
                }
            } else {
                console.log('after pulling in the parameter')

                let orderSource = this.view
                if (orderSource === 'All') {
                    orderSource = 'ANY PRODUCT'
                }


                if (window.sessionStorage.getItem("_customerOrdersSearch") === null) {

                    this.$parent.searchParams = {
                        orderSource: orderSource,
                        orderSourceId: null,
                        orderStatus: 'ANY STATUS',
                        orderFreeText: '',
                        top: 20,
                        pagination: 20,
                        skip: 0,
                        salesDateRange: [],
                        startDate: '',
                        endDate: ''
                    }

                    this.$parent.searchParams.startDate = moment().startOf('month').format('YYYY-MM-DD')
                    this.$parent.searchParams.endDate = moment().endOf('month').format('YYYY-MM-DD')


                    console.log('null storage')
                    console.log(this.$parent.searchParams)
                } else {
                    const searchParamFromStorage = JSON.parse(window.sessionStorage.getItem("_customerOrdersSearch"))
                    console.log('RIFATRIFAT')


                    if (searchParamFromStorage['orderSource'] != this.view) {

                        this.$parent.searchParams = {
                            orderSource: orderSource,
                            orderSourceId: null,
                            orderStatus: 'ANY STATUS',
                            orderFreeText: '',
                            top: 20,
                            pagination: 20,
                            skip: 0,
                            salesDateRange: [],
                            startDate: '',
                            endDate: ''
                        }

                        this.$parent.searchParams.startDate = searchParamFromStorage.startDate;
                        this.$parent.searchParams.endDate = searchParamFromStorage.endDate;

                        console.log(searchParamFromStorage['orderFromDate'] + ' fromDate')
                        console.log(searchParamFromStorage['orderToDate'] + ' toDate')

                        console.log('from storage')
                        console.log(this.$parent.searchParams)
                    } else {
                        this.$parent.searchParams = {
                            orderSource: orderSource,
                            orderSourceId: null,
                            orderStatus: searchParamFromStorage['orderStatus'],
                            orderFreeText: searchParamFromStorage['orderFreeText'],
                            top: 20,
                            pagination: 20,
                            skip: 0,
                            salesDateRange: [],
                            startDate: '',
                            endDate: ''
                        }

                        console.log(searchParamFromStorage['orderFromDate'] + ' fromDate')
                        console.log(searchParamFromStorage['orderToDate'] + ' toDate')

                        this.$parent.searchParams.startDate = searchParamFromStorage.startDate;
                        this.$parent.searchParams.endDate = searchParamFromStorage.endDate;

                        console.log('from storage')
                        console.log(this.$parent.searchParams)
                    }
                }
                // todo the search works orders pages spec out initial search criteria and pass into here with orders array and the parent gets updated with the results
            }

            this.constructQueryString()
        },
        beforeUpdate() {
            console.log('before update')
            console.log(JSON.stringify(this.$parent.searchParams))
            window.sessionStorage.setItem('_customerOrdersSearch', JSON.stringify(this.$parent.searchParams));
        },
        methods: {
            constructQueryString() {
                this.parameters = []

                let searchTerms = Object.assign({}, this.$parent.searchParams)

                console.log(this.queryRouteUrl)

                if(searchTerms.orderFreeText !== '') {
                    this.parameters.push('freetext=' + searchTerms.orderFreeText)
                }

                if (searchTerms.orderSource !== null && searchTerms.orderSource !== '' && searchTerms.orderSource !== 'ANY PRODUCT') {
                    this.parameters.push('source=' + searchTerms.orderSource)
                }

                if (searchTerms.orderStatus !== null && searchTerms.orderStatus !== '' && searchTerms.orderStatus !== 'ANY STATUS') {
                    this.parameters.push('status=' + searchTerms.orderStatus)
                }

                this.parameters.push('startDate=' + searchTerms.startDate)
                this.parameters.push('endDate=' + moment(searchTerms.endDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD'))

                if (JSON.parse(this.returnCookie("_role")).includes('Customer')) {
                    if (searchTerms.orderSource === 'Photofixr') {
                        this.parameters.push('myCustomerRef=' + JSON.parse(this.returnCookie("_customer")).ref)

                        // this.sourceQueryOptions.push('customerRef+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
                        // this.queryOptions.push('branch+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
                    } else {
                        this.parameters.push('myCustomerRef=' + JSON.parse(this.returnCookie("_customer")).ref)
                        this.parameters.push('photofixr=true')
                        // this.sourceQueryOptions.push('customerRef+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
                        // this.sourceQueryOptions.push('branch+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
                    }
                }

                let getResults = this.queryRouteUrl + this.parameters.join('&') + '&skip=' + searchTerms.skip + '&top=' + searchTerms.top
                console.log('***** FINAL QUERY: PAGINATION *****')
                console.log(getResults)


                this.$parent.loading = true
                Axios.get(getResults, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.$parent.orders = response.data.value

                        console.log(this.$parent.orders.length)
                        for (let i = 0; i < this.$parent.orders.length; i++) {
                            this.$parent.orders[i].ordered = this.$parent.orders[i].ordered.split("T")[0]
                            if (this.$parent.orders[i].created !== null) {
                                this.$parent.orders[i].created = this.$parent.orders[i].created.split("T")[0]
                            }
                            // this.$parent.orders[i].BillVatTotal = this.$parent.orders[i].BillVatTotal.toFixed(2)
                        }
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        if (error.response.status === 500) {
                            this.$parent.orders = []
                        }
                    })

                let getCounts = this.queryRouteUrl + this.parameters.join('&') + '&count=true&top=0'
                console.log('***** FINAL QUERY: COUNTS *****')
                console.log(getCounts)

                // this.$parent.loading = true // todo this might be an issue with the true and false
                Axios.get(getCounts, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        console.log(response.data['@odata.count'])
                        this.$parent.resultsCount = response.data['@odata.count']
                        console.log('handling change')
                        // this.handleCurrentChange(1)

                        // console.log(this.$parent.customers.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        // }
                    })
            },
            // constructQueryString_old() {
            //
            //     // this.searchParams.top = 20;
            //     // this.searchParams.skip = 0;
            //     //
            //     // this.queryOptions = []
            //     // this.freetextQueryOptions = []
            //     // this.sourceQueryOptions = []
            //
            //     let searchTerms = Object.assign({}, this.$parent.searchParams)
            //
            //
            //     let baseQueryUri = this.serviceRouteUrl + this.resourcePath
            //
            //     this.finalQuery = ''
            //
            //     if (searchTerms.orderFreeText !== '') {
            //         this.freetextQueryOptions.push('JobId in (\'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('OrderId in (\'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('JobId in (\'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(BillDescription, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(JobName, \'' + searchTerms.orderFreeText + '\')')
            //     }
            //
            //     // todo need to add territory in the freetext search and the assigned to
            //
            //     if (searchTerms.orderSource !== null && searchTerms.orderSource !== '' && searchTerms.orderSource !== 'ANY PRODUCT') {
            //         this.queryOptions.push('source+eq+\'' + searchTerms.orderSource + '\'')
            //     }
            //
            //     if (searchTerms.orderStatus !== null && searchTerms.orderStatus !== '' && searchTerms.orderStatus !== 'ANY STATUS') {
            //         this.queryOptions.push('status+eq+\'' + searchTerms.orderStatus + '\'')
            //     }
            //
            //     this.queryOptions.push('ordered+gt+' + searchTerms.salesDateRange[0] + 'T00:00:00.000Z')
            //
            //     // if (searchTerms.salesDateRange[0] === searchTerms.salesDateRange[1]) {
            //     //     searchTerms.salesDateRange[1] = moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
            //     this.queryOptions.push('+lt+' + moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD') + 'T00:00:00.000Z')
            //     // } else {
            //     //     this.queryOptions.push('ordered+lt+' + searchTerms.salesDateRange[1] + 'T00:00:00.000Z')
            //     // }
            //
            //     if (this.returnCookie("_role") === 'Customer') {
            //         if (searchTerms.orderSource === 'Photofixr') {
            //             this.sourceQueryOptions.push('customerRef+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
            //             // this.queryOptions.push('branch+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
            //         } else {
            //             this.sourceQueryOptions.push('customerRef+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
            //             this.sourceQueryOptions.push('branch+eq+\'' + JSON.parse(this.returnCookie("_customer")).ref + '\'')
            //         }
            //     }
            //
            //     // this.queryOptions.push('branch+eq+\'PFCC1\'')
            //
            //     // console.log(this.finalQuery)
            //     // console.log('&$branch+eq+' + JSON.parse(this.returnCookie("_customer")).ref)
            //
            //     if (searchTerms.orderFreeText !== '') {
            //         this.finalQuery = baseQueryUri.concat('(' + this.freetextQueryOptions.join(this.queryConcatOr) + ')', this.queryConcatAnd, this.queryOptions.join(this.queryConcatAnd))
            //     } else {
            //         this.finalQuery = baseQueryUri.concat(this.queryOptions.join(this.queryConcatAnd))
            //     }
            //
            //
            //     if (this.returnCookie("_role") === 'Customer') {
            //         this.finalQuery = this.finalQuery.concat(this.queryConcatAnd, '(' + this.sourceQueryOptions.join(this.queryConcatOr) + ')')
            //     }
            //
            //     this.finalQuery = this.finalQuery.concat('&$orderby=Ordered desc')
            //
            //
            //
            //     let getResults = this.queryRouteUrl + this.parameters.join('&') + '&skip=' + searchTerms.skip + '&top=' + searchTerms.top
            //     console.log('***** FINAL QUERY: PAGINATION *****')
            //     console.log(getResults)
            //
            //
            //     this.$parent.loading = true
            //     Axios.get(getResults, this.returnHeaderUsingToken())
            //         .then(response => {
            //             console.log(response)
            //             this.$parent.orders = response.data.value
            //
            //             console.log(this.$parent.orders.length)
            //
            //
            //             // this.$parent.searchParams.currentPage = 1;
            //
            //             // this.searchParams.top = 20;
            //             // this.searchParams.skip = 0;
            //             // this.orders
            //             // this.jobs = response.data.result.reverse()
            //             // //
            //             for (let i = 0; i < this.$parent.orders.length; i++) {
            //                 this.$parent.orders[i].ordered = this.$parent.orders[i].ordered.split("T")[0]
            //                 if (this.$parent.orders[i].created !== null) {
            //                 this.$parent.orders[i].created = this.$parent.orders[i].created.split("T")[0]
            //                 }
            //                 // this.$parent.orders[i].BillVatTotal = this.$parent.orders[i].BillVatTotal.toFixed(2)
            //             }
            //             this.$parent.loading = false
            //         })
            //         .catch(error => {
            //             this.$parent.loading = false
            //             if (error.response.status === 500) {
            //                 this.$parent.orders = []
            //             }
            //         })
            //
            //     let getCounts = this.queryRouteUrl + this.parameters.join('&') + '&count=true&top=0'
            //     console.log('***** FINAL QUERY: COUNTS *****')
            //     console.log(getCounts)
            //
            //     // this.$parent.loading = true // todo this might be an issue with the true and false
            //     Axios.get(getCounts, this.returnHeaderUsingToken())
            //         .then(response => {
            //             console.log(response.data)
            //             console.log(response.data['@odata.count'])
            //             this.$parent.resultsCount = response.data['@odata.count']
            //             console.log('handling change')
            //             // this.handleCurrentChange(1)
            //
            //             // console.log(this.$parent.customers.length)
            //             this.$parent.loading = false
            //         })
            //         .catch(error => {
            //             this.$parent.loading = false
            //             // if (error.response.status === 500) {
            //             // }
            //         })
            // },
            getOrders(searchParams) {

                this.$refs[searchParams].validate((valid) => {
                    if (valid) {

                        this.$parent.searchParams.skip = 0;
                        this.$parent.searchParams.currentPage = 1;

                        this.constructQueryString()

                    } else {
                        return false;
                    }
                })
            },
            getPaginatedResults() {
                this.constructQueryString()
            },
            getTo(page) {
                switch (page) {
                    case 'Toolkit':
                        page = 'toolkit'
                        break;
                    case 'Photofixr':
                        page = 'photofixr'
                        break;
                    case 'Bespoke':
                        page = 'bespoke'
                        break;
                    case 'PDFUpload':
                        page = 'instant-print'
                        break;
                    case 'Email':
                        page = 'email'
                        break;
                    case 'IMA':
                        page = 'directmailr'
                        break;
                    default:
                        page = 'all'
                }

                Router.push({
                    name: '/orders/' + page
                });
            }
        }
    };
</script>